/*
 * select.tsx
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import IconsStyles from 'Icon/Icons.less';
import Styles from './index.less';
var Select = function (_a) {
    var _b, _c;
    var list = _a.list, _d = _a.tableList, tableList = _d === void 0 ? [] : _d, selectedTable = _a.selectedTable, selected = _a.selected, cb = _a.cb, keyJson = _a.keyJson;
    var _e = useState('normal'), type = _e[0], setType = _e[1];
    var selectRef = useRef(null);
    var _f = useState(''), reg = _f[0], setReg = _f[1];
    var _g = useState(keyJson ? keyJson[selected] : selected), value = _g[0], setValue = _g[1];
    var _h = useState(''), selectedLine = _h[0], setSelectLine = _h[1];
    var _j = useState(null), selectedTableLineIndex = _j[0], setSelectedTableLineIndex = _j[1];
    var _k = useState(false), showOption = _k[0], setShowOption = _k[1];
    useEffect(function () {
        document.addEventListener('mousedown', function (e) {
            var _a;
            var target = e.target;
            if (!((_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                setReg('');
                setShowOption(false);
            }
        });
    }, []);
    useEffect(function () {
        if (type === 'normal' && selected) {
            setValue(keyJson ? keyJson[selected] : selected);
            setReg('');
        }
    }, [selected]);
    useEffect(function () {
        if (type === 'table' &&
            selectedTable.tableId &&
            selectedTable.tableKey &&
            selectedTable.lineKey) {
            setValue(selectedTable.lineName + (selectedTable.lineIndex + 1));
        }
    }, [selectedTable]);
    var handlechange = function (e) {
        setValue(e.target.value);
        setReg(e.target.value);
    };
    var getDepthItem = function (data) {
        if (data.length > 0) {
            var lineData_1 = data[0];
            var arr = [];
            for (var i = 0; i < data[0].lineDepth; i++) {
                arr.push(i);
            }
            return arr.map(function (item, index) {
                return (React.createElement("span", { className: Styles.addWordsOption, onClick: function () {
                        setSelectedTableLineIndex(item);
                        setShowOption(false);
                        cb &&
                            cb({
                                data: data,
                                index: item,
                            }, (lineData_1 === null || lineData_1 === void 0 ? void 0 : lineData_1.isLlm) ? 'llmTable' : type);
                    }, key: data[0].lineKey + (item + 1) },
                    "\u6570\u503C",
                    item + 1));
            });
        }
        else {
            return null;
        }
    };
    return (React.createElement("div", { ref: selectRef, className: Styles.selectArea },
        React.createElement("input", { onChange: function (e) { return handlechange(e); }, onFocus: function () { return setShowOption(true); }, value: value, className: Styles.selectInput }),
        React.createElement("span", { onClick: function () { return setShowOption(!showOption); }, className: classNames((_b = {}, _b[IconsStyles['icon-up']] = showOption, _b), (_c = {}, _c[IconsStyles['icon-down']] = !showOption, _c), Styles.selectIcons) }),
        showOption ? (React.createElement("div", { className: Styles.optionList },
            React.createElement("p", { className: Styles.headerClickText },
                React.createElement("a", { style: { color: type === 'normal' ? '#5582F3' : null }, onClick: function () { return setType('normal'); } }, "\u666E\u901A\u5B57\u6BB5"),
                React.createElement("a", { style: { color: type === 'table' ? '#5582F3' : null }, onClick: function () { return setType('table'); } }, "\u5217\u8868\u5B57\u6BB5")),
            React.createElement("div", { className: Styles.scrollBody }, type === 'normal' ? (list
                .filter(function (listItem) {
                var str = keyJson ? keyJson[listItem.key] : listItem.key;
                return str.indexOf(reg) !== -1;
            })
                .map(function (item) {
                return (React.createElement("div", { onClick: function () {
                        setShowOption(false);
                        cb && cb(item, type);
                    }, key: item.key, className: classNames(Styles.addWordsOption) }, keyJson ? keyJson[item.key] : item.key));
            })) : (React.createElement("div", { className: Styles.tableScrollBody },
                React.createElement("div", { className: Styles.left }, tableList.map(function (item) {
                    return (React.createElement("span", { className: Styles.addWordsOption, onClick: function () {
                            setSelectLine(item.lineKey);
                        }, key: "".concat(item.tableKey, "+").concat(item.lineKey) }, item.lineName));
                })),
                React.createElement("div", { className: Styles.right }, getDepthItem(tableList.filter(function (item) { return item.lineKey === selectedLine; })))))))) : null));
};
export default Select;
